import { useCallback } from "react";
import { useDateFormatter } from "./date";
import { capitalizeFirstLetter } from "../utils";
import { PayrollBreakdown } from "../__generated__/graphql";
import { useI18n } from "./i18n-hooks";

type PayrollBreakdownFormatterResult = {
    formatMonthYear: (pb: PayrollBreakdown) => string;
    formatPayrollDuration: (pb: PayrollBreakdown) => string;
};

export const usePayrollBreakdownFormatter = (): PayrollBreakdownFormatterResult => {
    const intlFormat = useDateFormatter();
    const i18n = useI18n();

    const formatMonthYear = useCallback(
        (pb: PayrollBreakdown) => {
            return capitalizeFirstLetter(
                intlFormat(new Date(pb.yearMonth), {
                    year: "numeric",
                    month: "long",
                }),
            );
        },
        [intlFormat],
    );
    const formatPayrollDuration = useCallback(
        (pb: PayrollBreakdown) => {
            if (pb.startDate > pb.endDate) {
                // this range occurs when a monthly mission start after the 20 of the first month.
                return "--";
            }
            const format = { day: "2-digit", month: "2-digit" } as const;
            const start = intlFormat(pb.startDate, format);
            const end = intlFormat(pb.endDate, format);
            return i18n.t("utils.period", { fromDate: start, toDate: end });
        },
        [i18n, intlFormat],
    );
    return {
        formatPayrollDuration,
        formatMonthYear,
    };
};
